import React, { useState } from "react";
import "./Contact.css";

const Contact = () => {

  // STATES
  const [name, setName] = useState("");
  const [phone, setPhone] = useState("");
  const [gram, setGram] = useState("");
  const [purity, setPurity] = useState("");

  // SUBMIT FUNCTION
  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!name || !phone) {
      alert("Please fill required fields");
      return;
    }

    const formData = new FormData();
    formData.append("name", name);
    formData.append("phone", phone);
    formData.append("purity", purity);
    formData.append("gram", gram);

    try {
      const res = await fetch("https://cashforgold.org.in/send.php", {
        method: "POST",
        body: formData,
      });

      const text = await res.text();
      console.log("SERVER RESPONSE:", text);

      let data;
      try {
        data = JSON.parse(text);
      } catch {
        alert("Invalid server response ❌");
        return;
      }

      if (data.status === "success") {
        alert("Message sent successfully ✅");

        // CLEAR FORM
        setName("");
        setPhone("");
        setGram("");
        setPurity("");
      } else {
        alert("Error sending message ❌");
      }

    } catch (err) {
      console.error(err);
      alert("Server error ❌");
    }
  };

  return (
    <section className="contact">
      <div className="contact-wrapper">

        {/* LEFT */}
        <div className="contact-info">
          <h2>Contact Us</h2>
          <p className="subtitle">Get in touch with us</p>

          <p className="desc">
            At Cash for Gold, we're here to help you sell gold easily.
          </p>

          <div className="info-card">
            <div className="icon">📞</div>
            <div>
              <h4>Contact</h4>
              <span>Mobile: 9010060007</span>
            </div>
          </div>
        </div>

        {/* RIGHT FORM */}
        <div className="contact-form">
          <h3>Ready to Get Started?</h3>

          <form onSubmit={handleSubmit}>

            {/* NAME */}
            <div className="input-group">
              <input
                type="text"
                required
                value={name}
                onChange={(e) => setName(e.target.value)}
              />
              <label>Your Name</label>
            </div>

            {/* PHONE */}
            <div className="input-group">
              <input
                type="tel"
                required
                value={phone}
                onChange={(e) => setPhone(e.target.value)}
              />
              <label>Your Phone</label>
            </div>

            {/* GRAM */}
            <div className="input-group">
              <input
                type="text"
                required
                value={gram}
                onChange={(e) => setGram(e.target.value)}
              />
              <label>No of Gram</label>
            </div>

            {/* PURITY */}
            <div className="input-group">
              <select
                required
                value={purity}
                onChange={(e) => setPurity(e.target.value)}
              >
                <option value=""></option>
                <option value="18K">18K</option>
                <option value="20K">20K</option>
                <option value="22K">22K</option>
                <option value="24K">24K</option>
              </select>
              <label>Gold Type</label>
            </div>

            <button type="submit">Send Message</button>

          </form>
        </div>

      </div>
    </section>
  );
};

export default Contact;